import { Injectable } from '@angular/core';
import { NetworkService } from '../infrastructure/network.service';
import { ConfigService } from '../infrastructure/config.service';
import { BehaviorSubject } from 'rxjs';
import { saveAs } from 'file-saver';

@Injectable()
export class SeedReservationService {
  isBackDropVisible = new BehaviorSubject<boolean>(false);
  seedReservationId = new BehaviorSubject<[number, boolean]>([0, false]);

  constructor(public configService: ConfigService,
    public networkService: NetworkService) {
    this.seedReservationId = new BehaviorSubject<[number, boolean]>([0, false]);
  }

  public setseedReservationId(value: number, isUpdate: boolean) {
    this.seedReservationId.next([value, isUpdate]);

  }

  public base64toFile(base64String, contentType, fileName) {
    const blob = this.b64toBlob(base64String, contentType, 550);
    saveAs(blob, fileName);
  }

  // Convert b64 to BLOB
  public b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    b64Data = b64Data.replace(/\s/g, ''); // IE compatibility...
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  public getLandingData(dashboardFilter: any) {
    return this.networkService.postRequest(this.configService.getSeedReservationLandingDataUrl(), dashboardFilter);
  }

  public getConfirmationData(seedReservationId: number) {
    return this.networkService.getRequest(this.configService.getSeedReservationConfirmationDataUrl() + '?seedReservationId=' + seedReservationId);
  }

  public getAccountList() {
    return this.networkService.getRequest(this.configService.getSeedReservationAccountListUrl());
  }

  public exportToExcel(dashboardFilter: any) {
    return this.networkService.postRequest(this.configService.exportToExcelSeedReservationDataUrl, dashboardFilter);
  }

  public exportReconciliationToExcel(dashboardFilter: any) {
    return this.networkService.postRequest(this.configService.exportReconciliationToExcelSeedReservationDataUrl, dashboardFilter);
  }

  public getSeedReservationMasterData(isForUpdate) {
    return this.networkService.getRequest(this.configService.getSeedReservationMasterDataUrl() + '?isForUpdate=' + isForUpdate);
  }

  public SaveSeedReservation(data) {
    return this.networkService.postRequest(this.configService.SaveSeedReservationOrderUrl(), data);
  }
  public getSalesAccountList(data: number) {
    return this.networkService.postRequest(this.configService.getSeedReservationSalesAccountListUrl(),data);
  }
  public downloadPdfForMobile(seedReservationId) {
    return this.networkService.getRequest(this.configService.getSeedReservationPdfUrl() + '?seedReservationId=' + seedReservationId);
  }

  public exisitingSeedReservationData(data) {
    return this.networkService.postRequest(this.configService.getExisitngSeedReservationURL(), data);
  }

  public deleteReservation(seedReservationId: number) {
    return this.networkService.getRequest(this.configService.DeleteReservationOrderUrl() + '?seedReservationId=' + seedReservationId);
  }
  public getRetailAccountID(accounNumber: number, growerID: number) {
    return this.networkService.getRequest(
      this.configService.GetReailerAccountIDUrl() +
      '?accounNumber=' + accounNumber +
      '&growerID=' + growerID
    );
  }

  // pdf from base64 date
  public sendBaseDate(filters) {
    return this.networkService.postRequest(this.configService.postFileForPdf(), filters);
  }
}
